import { createContext } from "react";

export const ConfiguredByParentContext = createContext(false);
